import { useRef } from "react";
import { DataTable } from "../../utils/data_table";
import { EllipsisMenu } from "../../utils/ellipsis_menu";
import { useApiMutation } from "../../utils/api";
import { useModal } from "../../utils/modal_launcher";
import { UserModal } from "./user_modal";

export const AdminUsers = () => {
  const tableRef = useRef<any>(null);
  const userModal = useModal(UserModal, {
    refetch: () => tableRef.current?.refetch(),
  });
  const { post } = useApiMutation();

  const become = (id) => {
    post(`/api/common/become/${id}`).then(({ data }) => {
      document.location = "/";
    });
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Users</h1>

      <DataTable
        ref={tableRef}
        url="/api/admin/users"
        columns={[
          { key: "email" },
          { key: "first_name" },
          { key: "last_name" },
          { key: "role" },
          {
            key: "settings",
            header: "",
            cellClass: "text-end",
            value: (user) => (
              <>
                <EllipsisMenu
                  actions={[
                    {
                      label: "Edit",
                      action: () => userModal.show(user),
                    },
                    { separator: true },
                    {
                      label: "Become",
                      action: () => become(user.id),
                    },
                  ]}
                />
              </>
            ),
          },
        ]}
      />
    </div>
  );
};
